import React, { useEffect, useRef } from 'react';



const PlayerFact = ({ fact }) => {
    const factRef = useRef(null);

    return (
        <div
            ref={factRef}
            data-splitting="lines"
            className="player-facts-fact"
            dangerouslySetInnerHTML={{ __html: fact.value }}

        />
    );
};

export default PlayerFact;